import { InAppBrowserService } from './in-app-browser.service';

export const InAppBrowserModule = angular
  .module('sfMobile.services.in-app-browser', [])
  .service('inAppBrowserService', InAppBrowserService).name;
